<template>
    <div>
        <el-button
            class="el-button--corwin-green proof-btn"
            :disabled="hasGeneratedProof"
            :class="{ 'proof-btn-highlight': !hasGeneratedProof }"
            @click="viewProof()"
        >
            Click Here to Proof Your Newsletter
        </el-button>
        <el-checkbox
            :disabled="!hasGeneratedProof"
            :title="
                hasGeneratedProof
                    ? null
                    : 'Click button on left to generate a proof for your newsletter.'
            "
            class="ml-10 proofed-checkbox"
            :class="{ 'checkbox-highlight': hasGeneratedProof }"
            style="float: right"
            v-model="form.proofed"
        >
            <h2>I have proofed my newsletter</h2>
        </el-checkbox>
        <form-feedback :form="form" field="proofed" />
        <div class="proof-info">
            <p class="mb-4">
            <strong>Important Notice:</strong> While Corwin provides a complimentary 
            Internal Proof, we cannot guarantee to catch every mistake. You are 
            responsible for ensuring your submitted information is correct and readable. 
            Corwin does not proofread proper names in articles or list columns - 
            please verify these carefully.
            </p>

            <p class="mb-4">
            <em>Note:</em> You must complete all steps before proofing your newsletter.
            Filler articles and additional Corwin content will be added after you
            submit your order.
            </p>

            <div class="photo-upload-section mt-5">
            <h4 class="mb-3">Photo Page Upload Guidelines</h4>
            <p>
                This uploader accepts only 8.5" x 11" full page, print-ready PDFs.
                For individual photos:
                <ul class="mt-2">
                <li>Return to Step 1 to upload individual photos</li>
                <li>Use article spaces in Step 1 if you cannot create print-ready designs</li>
                <li>Acrobat Reader is required for provided templates</li>
                </ul>
            </p>
            </div>
        </div>
        <div style="max-width: 1000px" v-loading="uploadForm.busy">
            <div
                class="d-inline-block"
                style="max-width: 320px; vertical-align: top"
            >
                <el-button
                    class="btn-block el-button--corwin-green"
                    icon="mdi mdi-upload"
                    @click="$refs.filePhotoPage.click()"
                    >Upload Photo Page
                </el-button>
                <!--<input type="file" ref="filePhotoPage" class="d-none"
                       @change="onChangePhotoPage" accept="image/jpeg,image/png,application/pdf,.doc,.docx" />-->
                <input
                    type="file"
                    ref="filePhotoPage"
                    class="d-none"
                    @change="onChangePhotoPage"
                    accept="application/pdf"
                />
                <el-button
                    class="btn-block"
                    type="primary"
                    icon="mdi mdi-download"
                    @click="downloadTemplate()"
                >
                    Download Photo Page Template
                </el-button>
            </div>
            <div
                class="d-inline-block align-top photo-page"
                v-for="(item, index) in pagePhotos"
                :key="index"
            >
                <pdf-preview
                    :url="item.url"
                    class="photo-page-pdf"
                    v-if="checkFileType(item) === 'pdf'"
                />
                <img
                    class="photo-page-image"
                    v-if="checkFileType(item) === 'image'"
                    :src="item.url"
                />
                <button
                    type="button"
                    class="remove-photo-page"
                    @click="
                        removePhotoPage(index, item.media_id, item.upload_id)
                    "
                >
                    &times;
                </button>
            </div>
        </div>
        <div class="mt-20" id="proof-pdf" v-if="viewingProof"></div>
    </div>
</template>

<script>
import FileUtils from "@/utils/file";
import PdfPreview from "../../../../components/PdfPreview";

export default {
    props: {
        form: {
            type: Object,
            required: true
        },
        newsletter: {
            type: Object,
            required: true
        }
    },
    components: {
        PdfPreview
    },
    data() {
        return {
            viewingProof: false,
            uploadForm: new Form({
                file: null
            }),
            upload: null,
            pagePhotos: [],
            pagePhoto: {
                upload_id: null,
                media_id: null,
                type: null,
                url: null
            }
        };
    },
    mounted() {
        this.photoPagePreview();
    },
    computed: {
        hasGeneratedProof() {
            return this.form.proofed || this.viewingProof;
        }
    },
    methods: {
        viewProof() {
            if (this.viewingProof) {
                return;
            }
            this.viewingProof = true;
            Vue.nextTick(() => {
                PDFObject.embed(
                    `/web-api/newsletter/${this.newsletter.id}/proof`,
                    "#proof-pdf"
                );
                this.updateScroller();
                this.$parent.scrollTo({
                    el: "#proof-pdf"
                });
            });
        },
        downloadTemplate() {
            window.open(
                `/downloadables/Photo_Page_Templates.zip?082724`,
                "_blank"
            );
        },
        onChangePhotoPage(e) {
            if (e.target.files.length && this.pagePhotos.length < 3) {
                let file = e.target.files[0];
                if (file.type != "application/pdf") {
                    this.$alert(
                        "The photo page must be in PDF format. Please save your file as a PDF to upload.",
                        {
                            confirmButtonText: "OK",
                            type: "warning"
                        }
                    );
                    return;
                }
                FileUtils.checkFileSize(file).then(() => {
                    this.form.remove_photo_page = false;
                    this.uploadForm.file = file;
                    App.postData(
                        `/web-api/upload?include=media`,
                        this.uploadForm
                    ).then((response) => {
                        this.upload = response.data;
                        this.pagePhoto.upload_id = this.upload.id;
                        this.pagePhoto.media_id = this.upload.media.id;
                        this.pagePhoto.type = this.upload.media.mime_type;
                        this.pagePhoto.url = this.upload.url;
                        this.pagePhotos.push({ ...this.pagePhoto });
                        this.form.upload_photo_pages.push(this.upload.id);
                        this.updateScroller();
                    });
                });
            } else {
                this.$alert("You need add maximum 3 photo page!", {
                    confirmButtonText: "OK",
                    type: "warning"
                });
            }
        },
        removePhotoPage(index, media_id, upload_id) {
            this.$confirm(
                "Are you sure you want to remove photo page?",
                "Confirmation",
                {
                    confirmButtonText: "Remove",
                    confirmButtonClass: "el-button--danger",
                    cancelButtonText: "Cancel",
                    type: "warning"
                }
            ).then(() => {
                axios.delete(`/web-api/upload/${media_id}`).then((response) => {
                    if (response.data.status == "200") {
                        this.pagePhotos.splice(index, 1);
                        if (upload_id != null) {
                            let upload_index =
                                this.form.upload_photo_pages.indexOf(upload_id);
                            this.form.upload_photo_pages.splice(
                                upload_index,
                                1
                            );
                        }
                    }
                });
            });
        },
        checkFileType(item) {
            if (item.type) {
                if (item.type.includes("image/")) {
                    item.type = "image";
                } else {
                    switch (item.type) {
                        case "application/pdf":
                            item.type = "pdf";
                            break;
                        case "application/msword":
                        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                            item.url =
                                "/images/microsoft-word-document-icon.png";
                            item.type = "image";
                            break;
                    }
                }
            }
            return item.type;
        },
        photoPagePreview() {
            if (this.newsletter.photo_pages) {
                let pages = this.newsletter.photo_pages.data;
                for (var i = 0; i < pages.length; i++) {
                    let page = pages[i];
                    this.pagePhoto.media_id = page.id;
                    this.pagePhoto.type = page.mime_type;
                    this.pagePhoto.url = page.url;
                    this.pagePhotos.push({ ...this.pagePhoto });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#proof-pdf {
    height: 800px;
}

.photo-page-image {
    width: 100%;
    max-width: 200px;
    margin-right: 5px;
}
.align-top {
    vertical-align: top;
}

.photo-page {
    position: relative;
}

.remove-photo-page {
    position: absolute;
    right: 5px;
    top: 0px;
    background-color: rgba(0, 0, 0, 0.5) !important;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 20px;
    line-height: 21px;
    font-size: 19px;
    font-weight: 500;
}

// Custom styles for the proofed checkbox
.el-checkbox.bold {
    // Increase clickable area and add highlight
    padding: 12px 24px 12px 12px;
    border-radius: 8px;
    box-shadow: 0 0 8px 2px #4caf5055, 0 0 0 3px #4caf5022;
    background: #f6fff6;
    transition: box-shadow 0.2s, background 0.2s;
    border: 2px solid #4caf50;
}
.el-checkbox.bold:hover,
.el-checkbox.bold:focus-within {
    box-shadow: 0 0 12px 4px #388e3c99, 0 0 0 4px #4caf5044;
    background: #e8ffe8;
    border-color: #388e3c;
}
.el-checkbox.bold .el-checkbox__input {
    transform: scale(1.5);
    margin-right: 12px;
}
.el-checkbox.bold .el-checkbox__inner {
    border: 2.5px solid #388e3c !important;
    background: #fff;
    width: 26px;
    height: 26px;
    border-radius: 6px;
    box-shadow: 0 0 0 2px #4caf5022;
}
.el-checkbox.bold .el-checkbox__input.is-checked .el-checkbox__inner {
    background: #4caf50 !important;
    border-color: #388e3c !important;
}
.el-checkbox.bold .el-checkbox__input.is-checked .el-checkbox__inner:after {
    border-color: #fff !important;
    border-width: 3px;
}
.el-checkbox.bold .el-checkbox__label {
    font-size: 1.25rem;
    font-weight: bold;
    color: #222;
    text-shadow: 0 1px 0 #fff;
}

// Highlight and sizing for proof button
.proof-btn {
    font-size: 1.25rem;
    padding: 18px 36px;
    border-radius: 10px;
    font-weight: bold;
    transition: box-shadow 0.2s, background 0.2s, border 0.2s;
    margin-bottom: 10px;
    margin-top: 10px;
}
.proof-btn-highlight {
    box-shadow: 0 0 8px 2px #4caf5055, 0 0 0 3px #4caf5022;
    //background: #f6fff6 !important;
    border: 2px solid #4caf50 !important;
    transition: box-shadow 0.2s, background 0.2s, border 0.2s;
    z-index: 1;
}
.proof-btn-highlight:hover,
.proof-btn-highlight:focus,
.proof-btn-highlight:focus-visible {
    box-shadow: 0 0 12px 4px #388e3c99, 0 0 0 4px #4caf5044;
    //background: #e8ffe8 !important;
    border-color: #388e3c !important;
}
// Highlight for checkbox
.checkbox-highlight {
    padding: 12px 24px 12px 12px;
    border-radius: 8px;
    box-shadow: 0 0 8px 2px #4caf5055, 0 0 0 3px #4caf5022;
    background: #f6fff6 !important;
    border: 2px solid #4caf50 !important;
    transition: box-shadow 0.2s, background 0.2s, border 0.2s;
    z-index: 1;
}
.checkbox-highlight:hover,
.checkbox-highlight:focus-within {
    box-shadow: 0 0 12px 4px #388e3c99, 0 0 0 4px #4caf5044;
    background: #e8ffe8 !important;
    border-color: #388e3c !important;
}
</style>
<style lang="scss">
.photo-page-pdf {
    .pdf {
        height: 200px;
        width: 200px;
    }
}
</style>
